// extracted by mini-css-extract-plugin
export default {"autosizeTextInputContainer":"autosize-text-input-module__autosizeTextInputContainer--EfjH6"};